export function FormButton({ title, image, onClick }: { title: string; image: string; onClick: () => void }) {
  return (
    <button className="flex flex-col h-64 w-64 gap-2 bg-gray-800 hover:bg-gray-400 rounded-2xl p-4" onClick={onClick}>
      <img className="h-32 w-32 mx-auto mt-auto" src={image} alt="" />
      <h2 className="text-center w-32 mx-auto text-lg font-bold mb-auto">{title}</h2>
    </button>
  );
}
